import { BaseApiClient } from "../api/baseApiClient.service";
import type { NotificationPreferences } from "../auth/auth.types";

/**
 * Service for reading and updating the user's email notification preferences
 * (GDPR opt-out for non-transactional mail).
 */
export class NotificationService {
	private static baseApi = BaseApiClient.getInstance();

	/**
	 * Get the authenticated user's current email notification preferences.
	 */
	static async getPreferences(): Promise<NotificationPreferences> {
		return NotificationService.baseApi.get<NotificationPreferences>(
			"user/notification-preferences",
		);
	}

	/**
	 * Update one or both email notification preferences.
	 * Only the provided fields are changed.
	 */
	static async updatePreferences(
		preferences: Partial<NotificationPreferences>,
	): Promise<NotificationPreferences> {
		return NotificationService.baseApi.patch<
			NotificationPreferences,
			Partial<NotificationPreferences>
		>("user/notification-preferences", preferences);
	}
}
